import {
  Box,
  Typography,
  Button,
  Grid,
  Container,
  IconButton,
} from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useTranslation } from "react-i18next";
import Footer from "../components/HomeComponent/Footer";
import globalStyles from "../global";
import News from "../components/globalCountries/countryhomepagescomponent/News";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CareerPageHome = () => {
  const { t, i18n } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const isRTL = i18n.dir() === "rtl";

  const styles = {
    root: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      direction: isRTL ? "rtl" : "ltr",
    },
    heroBanner: {
      display: "flex",
      flexDirection: { xs: "column", md: isRTL ? "row-reverse" : "row" },
      bgcolor: "white",
      alignItems: "center",
      minHeight: {
        xs: "280px",
        sm: "440px",
        md: "500px",
      },
    },
    imageContainer: {
      // display: { xs: "none", md: "block" },
      width: { md: "50%" },
      order: isRTL ? 1 : 2, // <-- yahan change kiya hai
    },
    heroImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
    textContainer: {
      width: { xs: "100%", md: "50%" },
      py: 6,
      px: 3,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      order: isRTL ? 2 : 1, // <-- yahan change kiya hai
    },
    innerContent: {
      maxWidth: "28rem",
      mx: "auto",
      width: "100%",
    },
    heroTitle: {
      fontSize: {
        md: "55px",
        sm: "36px",
        xs: "30px",
      },
      fontWeight: 400,
      mb: 3,
      color: "#65BA0D",

      fontFamily: "AllRoundGothicBold",
      textAlign: "left",
      textTransform: "uppercase",
    },
    heroDescription: {
      fontSize: { sm: "24px", xs: "20px" },
      mb: 4,
      fontWeight: 400,
      fontFamily: globalStyles.fonts.primary,
      textAlign: "centre",
      color: "#4D4D4D",
    },
    applyButton: {
      px: 6,
      py: 1,
      color: "white",
      fontSize: { sm: "18px", xs: "14px" },
      bgcolor: globalStyles.colors.uclean_green,
      borderRadius: 1,
      "&:hover": {
        bgcolor: globalStyles.colors.uclean_green,
        opacity: 0.9,
      },
    },
    talentDescription: {
      fontSize: { sm: "20px", xs: "16px" },
      lineHeight: "26px",
      letterSpacing: "0%",
      mb: 4,
      fontWeight: 400,
      fontFamily: globalStyles.fonts.primary,
      textAlign: "centre",
      color: "#4D4D4D",
      mt: 6,
    },
    statsSection: {
      bgcolor: "#f5f5f0",
      borderRadius: 2,
      p: 2.5,
      mt: "-3%",
    },
    statItem: {
      textAlign: "center",
      p: 2,
    },
    statNumber: {
      fontSize: { md: "36px", sm: "26px", xs: "22px" },
      lineHeight: "auto",
      letterSpacing: "0%",
      fontWeight: 600,
      color: globalStyles.colors.army_green,
      fontFamily: globalStyles.fonts.primary,
    },
    statLabel: {
      color: "text.secondary",
      fontFamily: globalStyles.fonts.primary,
      fontSize: { sm: "19.2px", xs: "16px" },
      lineHeight: "auto",
      letterSpacing: "0%",
    },
    benefitsSection: {
      py: 6,
      bgcolor: "white",
      my: 6,
    },
    benefitsTitle: {
      fontSize: { md: "40px", sm: "28px", xs: "24px" },
      lineHeight: "auto",
      letterSpacing: "1%",
      fontWeight: 600,
      mb: 4,
      color: globalStyles.colors.army_green,
      // textAlign: isRTL ? "right" : "left",
      fontFamily: "AllRoundGothicBold",
      // textAlign: "center",
      textTransform: "uppercase",
    },
    benefitCard: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
    benefitIcon: {
      width: "80px",
      height: "80px",
      objectFit: "contain",
      mb: 2,
    },
    benefitTitle: {
      fontSize: { sm: "22px", xs: "20px" },
      letterSpacing: "0%",
      fontWeight: 600,
      mt: 2,
      mb: 1.5,
      fontFamily: globalStyles.fonts.primary,
      color: "#003A26",
    },
    benefitDescription: {
      color: "text.secondary",
      fontFamily: globalStyles.fonts.primary,
      fontSize: { sm: "18px", xs: "14px" },
      lineHeight: "auto",
      letterSpacing: "0%",
    },
    joinSection: {
      py: 6,
      backgroundImage: `url(${imageBaseUrl}careerbg.png)`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "100%",
    },
    socialSection: {
      // display: "flex",
      // flexDirection: "column",
      // alignItems: "center",
      py: 6,
      backgroundImage: `url(${imageBaseUrl}careerbg.png)`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      // width: "75%",
      borderRadius: "16px",
      // ml: "13%",
      width: "100%",
      maxWidth: "1200px",
      mx: "auto",

      my: {
        sm: 8,
        xs: 4,
      },
    },
    socialTitle: {
      fontSize: { md: "45.45px", sm: "30px", xs: "26px" },
      fontWeight: 600,
      // mb: 4,
      color: globalStyles.colors.army_green,
      textAlign: "center",

      fontFamily: "AllRoundGothicBold",
      textTransform: "uppercase",
    },
    socialSubTitle: {
      fontSize: { md: "45.45px", sm: "30px", xs: "26px" },
      fontWeight: 600,
      mb: 2,
      color: globalStyles.colors.uclean_green,
      textAlign: "center",

      fontFamily: "AllRoundGothicBold",
      textTransform: "uppercase",
    },
    socialIconsContainer: {
      display: "flex",
      gap: 2,
      flexDirection: isRTL ? "row-reverse" : "row",
      justifyContent: "center",
      alignItems: "center",
    },
    socialIcon: {
      color: globalStyles.colors.army_green,
      transition: "all 0.2s ease-in-out",
      "&:hover": {
        color: globalStyles.colors.uclean_green,
        transform: "scale(1.1)",
      },
    },
    sliderTitle: {
      fontSize: { md: "40px", sm: "28px", xs: "24px" },
      fontWeight: 700,
      mb: 3,
      color: "#65BA0D",

      fontFamily: "AllRoundGothicBold",
      textAlign: "center",
      textTransform: "uppercase",
    },
    sliderContainer: {
      padding: "20px",
    },
    slideImage: {
      width: "100%",
      height: "auto",
      borderRadius: "8px",
    },
    activeRolesSection: {
      // padding: "20px",
      // textAlign: "center",
      backgroundColor: "FFF",
      // mt: "6%",
      width: "100%",
      maxWidth: "1200px",
      mx: "auto",
      py: 10,
      px: {
        sm: 0,
        xs: 1,
      },
    },
    activeTitle: {
      fontSize: { md: "40px", sm: "28px", xs: "24px" },
      fontWeight: 400,
      mb: 3,

      fontFamily: "AllRoundGothicBold",
      textAlign: "center",
      textTransform: "uppercase",
    },
    activeDescription: {
      fontSize: { sm: "20px", xs: "16px" },
      mb: 4,
      // textAlign: isRTL ? "right" : "left",
      fontFamily: globalStyles.fonts.primary,
      textAlign: "center",
      color: "#4D4D4D",
      letterSpacing: "1%",
      lineHeight: "100%",
    },
    activeRoleCard: {
      border: "1px solid #ddd",
      borderRadius: "15px",
      backgroundColor: "white",
      gap: 4,
      py: 4,
      px: 4, // mt: '6%',
    },
    activeRoleTitle: {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: { md: "30px", sm: "24px", xs: "20px" },
      lineHeight: "40px",
      letterSpacing: "1%",
      textTransform: "capitalize",
      color: globalStyles.colors.army_green,
      textAlign: "left",
    },
    activeRoleDate: {
      fontFamily: "Poppins",
      fontWeight: 400,
      fontSize: { sm: "12px", xs: "9px" },
      lineHeight: "40px",
      letterSpacing: "1%",
      textTransform: "capitalize",
      color: "#4D4D4D",
      marginBottom: "10px",
      textAlign: "left",
    },
    activeRoleDescription: {
      fontFamily: "Poppins",
      fontWeight: 400,
      fontSize: { sm: "18px", xs: "14px" },
      lineHeight: "24px",
      letterSpacing: "0%",
      textAlign: "justify",
      textTransform: "capitalize",
      color: "#4D4D4D",
      mb: 2,
    },

    activeRoleEmail: {
      color: globalStyles.colors.uclean_green,
      fontWeight: 600,
      fontSize: { sm: "18px", xs: "14px" },
      fontStyle: "Poppins",
      fontFamily: globalStyles.fonts.primary,
      border: `1px solid #65BA0D`,
      borderRadius: "6px",
      py: 1,
      px: {
        sm: 4,
        xs: 2,
      },
      textTransform: "none",
      textAlign: "left",
      alignSelf: "flex-start",

      "&:hover": {
        border: `1px solid #65BA0D`,
        color: globalStyles.colors.uclean_green,
        backgroundColor: "transparent", // optional: removes default hover bg
      },
    },
  };

  const careerStats = [
    { number: "12+", label: t("career.stats.offices") },
    { number: "500+", label: t("career.stats.employees") },
    { number: "7+", label: t("career.stats.departments") },
    { number: "2+", label: t("career.stats.regions") },
  ];

  const benefits = [
    {
      icon: "career_1.png",
      title: t("career.benefits.equalOpportunity.title"),
      description: t("career.benefits.equalOpportunity.description"),
    },
    {
      icon: "career_2.png",
      title: t("career.benefits.flexibleCulture.title"),
      description: t("career.benefits.flexibleCulture.description"),
    },
    {
      icon: "career_3.png",
      title: t("career.benefits.performance.title"),
      description: t("career.benefits.performance.description"),
    },
    {
      icon: "career_4.png",
      title: t("career.benefits.HorizontalOrganization.title"),
      description: t("career.benefits.HorizontalOrganization.description"),
    },
  ];

  const socialLinks = [
    {
      icon: <FacebookIcon />,
      url: "https://www.facebook.com/uclean.in",
      label: "Facebook",
    },
    {
      icon: <InstagramIcon />,
      url: "https://www.instagram.com/uclean.in",
      label: "Instagram",
    },
    {
      icon: <TwitterIcon />,
      url: "https://twitter.com/uclean_in",
      label: "Twitter",
    },
    {
      icon: <LinkedInIcon />,
      url: "https://www.linkedin.com/company/uclean",
      label: "LinkedIn",
    },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const activeRoles = [
    {
      title: "Senior PHP Developer",
      date: "Date Posted: February 16, 2024",
      description:
        "Seeking a Senior PHP Developer to design, develop, and optimize scalable web applications. Join our team to lead backend development, collaborate with cross-functional teams, and deliver innovative solutions.",
      email: "careers@uclean.in",
    },
    {
      title: "Senior PHP Developer",
      date: "Date Posted: February 16, 2024",
      description:
        "Seeking a Senior PHP Developer to design, develop, and optimize scalable web applications. Join our team to lead backend development, collaborate with cross-functional teams, and deliver innovative solutions.",
      email: "careers@uclean.in",
    },
    {
      title: "Senior PHP Developer",
      date: "Date Posted: February 16, 2024",
      description:
        "Seeking a Senior PHP Developer to design, develop, and optimize scalable web applications. Join our team to lead backend development, collaborate with cross-functional teams, and deliver innovative solutions.",
      email: "careers@uclean.in",
    },
    {
      title: "Senior PHP Developer",
      date: "Date Posted: February 16, 2024",
      description:
        "Seeking a Senior PHP Developer to design, develop, and optimize scalable web applications. Join our team to lead backend development, collaborate with cross-functional teams, and deliver innovative solutions.",
      email: "careers@uclean.in",
    },
  ];

  const lifeAtUcleanImages = [
    `${imageBaseUrl}image1.png`,
    `${imageBaseUrl}image2.png`,
    `${imageBaseUrl}image3.png`,
  ];

  return (
    <Box sx={styles.root}>
      <Box sx={styles.heroBanner}>
        <Box sx={styles.imageContainer}>
          <Box
            component="img"
            src={`${imageBaseUrl}career.png`}
            alt="UCLEAN Team"
            sx={styles.heroImage}
          />
        </Box>

        <Box sx={styles.textContainer}>
          <Box sx={styles.innerContent}>
            <Typography variant="h1" sx={styles.heroTitle}>
              {t("career.joinUs")}
            </Typography>
            <Typography sx={styles.heroDescription}>
              {t("career.joinUclean")}
            </Typography>
            <Box textAlign={isRTL ? "right" : "left"}>
              <Button sx={styles.applyButton}>{t("career.applyNow")}</Button>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={{ maxWidth: "1200px", width: "100%", mx: "auto" }}>
        <Box textAlign="center" py={6}>
          {/* <Typography variant="h2" sx={styles.heroTitle}>
            {t("career.lookingForTalent")}
          </Typography> */}
          <Typography sx={styles.talentDescription}>
            {t("career.talentDescription")}
          </Typography>
        </Box>

        <Grid container sx={styles.statsSection}>
          {careerStats.map((stat, index) => (
            <Grid item xs={12} md={3} key={index} sx={styles.statItem}>
              <Typography sx={styles.statNumber}>{stat.number}</Typography>
              <Typography sx={styles.statLabel}>{stat.label}</Typography>
            </Grid>
          ))}
        </Grid>

        <Box sx={styles.benefitsSection}>
          <Typography
            variant="h2"
            textAlign="left"
            sx={{
              ...styles.benefitsTitle,
              px: {
                xs: 2, // Adds horizontal padding on mobile
                sm: 0, // No padding on tablet and up
              },
            }}
          >
            {t("career.benefits.title")}
          </Typography>

          <Box sx={{ position: "relative" }}>
            <Grid container spacing={2}>
              {benefits.map((benefit, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Box
                    sx={{
                      ...styles.benefitCard,
                      px: { xs: 1, sm: 1.5 }, // responsive padding
                      py: 3,
                      position: "relative",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <Box
                      component="img"
                      src={`${imageBaseUrl}${benefit.icon}`}
                      alt={benefit.title}
                      sx={styles.benefitIcon}
                    />

                    <Typography
                      sx={{
                        ...styles.benefitTitle,
                      }}
                    >
                      {benefit.title === "Performance-first Culture" ? (
                        <>
                          Performance–first <br /> Culture
                        </>
                      ) : (
                        benefit.title
                      )}
                    </Typography>

                    <Typography
                      sx={{
                        ...styles.benefitDescription,
                      }}
                    >
                      {benefit.description}
                    </Typography>

                    {/* Divider for desktop only */}
                    {index < benefits.length - 1 && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: "5%",
                          right: 0,
                          height: "90%",
                          width: "1px",
                          backgroundColor: "#BBBBBB",
                          display: { xs: "none", sm: "none", md: "block" },
                        }}
                      />
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Box>

      {/* Life at UCLEAN Section */}
      <Box sx={{ py: 8, backgroundColor: "#f5f5f5" }}>
        <Box sx={{ maxWidth: "1200px", width: "100%", mx: "auto" }}>
          <Typography
            variant="h2"
            textAlign="center"
            sx={styles.sliderTitle}
            mb={4}
          >
            Life at UCLEAN!
          </Typography>
          <Box sx={styles.sliderContainer}>
            <Slider {...sliderSettings}>
              {lifeAtUcleanImages.map((image, index) => (
                <Box key={index} sx={{ px: 1 }}>
                  <Box
                    component="img"
                    src={image}
                    alt={`UCLEAN Life ${index + 1}`}
                    sx={styles.slideImage}
                  />
                </Box>
              ))}
            </Slider>
          </Box>
        </Box>
      </Box>

      {/* Active Roles Section */}
      <Box sx={styles.activeRolesSection}>
        <Box>
          <Typography variant="h2" sx={styles.activeTitle} mb={4}>
            Active Roles
          </Typography>
          <Typography sx={styles.activeDescription} mb={4}>
            We are always on the lookout for talented individuals to join our
            growing team. Please see our open vacancies below.
          </Typography>

          <Box
            sx={{
              width: "100%",
              maxWidth: "1116px",
              height: "auto",
              display: "flex",
              flexWrap: "wrap",
              gap: "11px",
              mb: 6,
              justifyContent: {
                xs: "center", // center on mobile
                md: "flex-start", // left-aligned on desktop
              },
              mx: "auto", // horizontally center container
            }}
          >
            {[
              "India",
              "UAE",
              "Somalia",
              "Sri Lanka",
              "Ghana",
              "Mauritius",
              "Nepal",
            ].map((role, index) => (
              <Box
                key={index}
                sx={{
                  width: {
                    xs: "45%", // 2 in a row on small screens
                    sm: "30%", // 3 in a row on tablets
                    md: "150px", // fixed width on desktop
                  },
                  height: "48.72px",
                  borderRadius: "10.36px",
                  border: "1.04px solid #BBBBBB",
                  boxShadow: "0px 4px 4px 0px #0000001F",
                  padding: "10.36px 20.72px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#FFFFFF",
                  fontFamily: "Poppins",
                  fontSize: { sm: "18px", xs: "14px" },
                  fontWeight: 500,
                  color: "#00000080",
                  cursor: "pointer",
                  transition: "all 0.3s ease",

                  "&:hover": {
                    backgroundColor: "#26684D1A",
                    border: "1.04px solid #174C2E",
                    boxShadow: "0px 4px 4px 0px #0000001F",
                    color: "#174C2E",
                    fontWeight: 600,
                  },
                }}
              >
                {role}
              </Box>
            ))}
          </Box>

          <Grid container spacing={2}>
            {activeRoles.map((role, index) => (
              <Grid
                item
                xs={12} // full width on mobile
                sm={12} // full width on small tablets
                md={6} // half width (2 per row) on desktop
                key={index}
              >
                <Box
                  sx={{
                    ...styles.activeRoleCard,
                    // padding: {
                    //   xs: "16px", // smaller padding for mobile
                    //   sm: "20px", // tablet
                    //   md: "24px", // desktop (keep existing)
                    // },
                  }}
                >
                  <Typography
                    sx={{
                      ...styles.activeRoleTitle,
                    }}
                  >
                    {role.title}
                  </Typography>

                  <Typography
                    sx={{
                      ...styles.activeRoleDate,
                    }}
                  >
                    {role.date}
                  </Typography>

                  <Typography
                    sx={{
                      ...styles.activeRoleDescription,
                      // fontSize: {
                      //   xs: "14px",
                      //   sm: "15px",
                      //   md: styles.activeRoleDescription?.fontSize || "16px",
                      // },
                      // mb: 2,
                    }}
                  >
                    {role.description}
                  </Typography>

                  <Box sx={{ textAlign: "left", width: "100%" }}>
                    <Button
                      variant="outlined"
                      sx={{
                        ...styles.activeRoleEmail,
                        // fontSize: {
                        //   xs: "13px",
                        //   sm: "14px",
                        //   md: styles.activeRoleEmail?.fontSize || "14px",
                        // },
                        // padding: {
                        //   xs: "6px 12px",
                        //   sm: "8px 16px",
                        //   md: "10px 20px",
                        // },
                      }}
                    >
                      Email: {role.email}
                    </Button>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>

      {/* Social Media Section */}
      <Box sx={styles.socialSection}>
        <Container sx={{}}>
          <Typography variant="h2" sx={styles.socialTitle}>
            {t("career.interested")}
          </Typography>
          <Typography variant="h2" sx={styles.socialSubTitle}>
            {t("career.interestedSubTitle")}
          </Typography>
          <Box sx={styles.socialIconsContainer}>
            {socialLinks.map((social, index) => (
              <IconButton
                key={index}
                component="a"
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                sx={styles.socialIcon}
              >
                {social.icon}
              </IconButton>
            ))}
          </Box>
        </Container>
      </Box>
      <News />
      <Box sx={{ height: { sm: "80px", xs: "20px" } }} />
      <Footer />
    </Box>
  );
};

export default CareerPageHome;
